import {AppPages, usePageUrl} from "../../app-layout/AppPages";
import {Button} from "@mui/material";
import {Link as RouterLink} from "react-router";
import React from "react";

export function BackHomeButton() {
    const pageUrl = usePageUrl(true);
    return pageUrl ? (
        <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to={pageUrl(AppPages.home)}
        >
            Back to Home
        </Button>
    ) : null;
}